//import $ from 'jquery'
//import jQuery from 'jquery'
import React from 'react'
import ReactDOM from 'react-dom'
import queryString from 'query-string'
//import queryString from 'querystring'
import styles from '../scss/app.scss'
import mktime from 'locutus/php/datetime/mktime'

//window.$ = jQuery
window.ReactDOM = ReactDOM
window.React = React
window.queryString = queryString
window.styles = styles

require.context('./', true, /\.js$/)

var cache = {}

//load all js modules
function importAll(r) {
	r.keys().forEach(key => cache[key] = r(key));
}

importAll(require.context('./', true, /\.js$/))

///IE11 fixings start
window.addEventListener("unhandledrejection", function(event) {
	console.warn("WARNING: Unhandled promise rejection. Reason: " + event.reason, event);
});

if ('NodeList' in window && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function(callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

if (window.Element && !Element.prototype.closest) {
	Element.prototype.closest =
		function(s) {
			var matches = (this.document || this.ownerDocument).querySelectorAll(s),
				i,
				el = this;
			do {
				i = matches.length;
				while (--i >= 0 && matches.item(i) !== el) {};
			} while ((i < 0) && (el = el.parentElement));
			return el;
		};
}

// von:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				if (this.parentNode !== null)
					this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
///IE11 fixings end